import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { OBI } from "../assets/obi";

const NotFoundPage = () => {
  const { t } = useLang();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16" data-testid="not-found-page">
      <div className="cartoon-card max-w-xl text-center p-10">
        <img src={OBI.empty} alt="OBI" className="w-52 h-52 mx-auto" />
        <h1 className="font-display font-bold text-6xl text-slate-900 mt-4">404</h1>
        <h2 className="font-display font-bold text-2xl mt-2">{t("notfound.title")}</h2>
        <p className="text-slate-600 mt-2">{t("notfound.sub")}</p>
        <Link to="/" className="cartoon-btn bg-yellow-300 mt-6 inline-flex">
          {t("notfound.cta")}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
